document.addEventListener('alpine:init', () => {
    Alpine.data('fakeSlider', (url, id) => ({
        sliderContainer: null,
        slider: null,
        modelId: id,
        url : url,
        init() {
            this.sliderContainer = this.$refs.sliderContainer;
        },
        slide() {
            // Ajaxing the URL with the ID as ?model_id = id and then the sliderContainer will be replaced with the response
            fetch(this.url + '?model_id=' + this.modelId + '&action=fake_slider_load')
                .then(response => response.text())
            // add it to the sliderContainer but no flickity
                .then(data => {
                    this.sliderContainer.innerHTML = data;
                });

        }
    }))
});
